<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="Avatar Rounded" pageTitle="Avatar Rounded" />
            <AvatarRounded />
            <div class="flex-grow-1"></div>
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader'
import PageTitle from '../Common/PageTitle'
import AvatarRounded from '../AvatarRounded/AvatarRounded'
import FooterArea from '../Layouts/FooterArea'

export default {
    name: 'AvatarRoundedPage',
    components: {
        MainHeader,
        PageTitle,
        AvatarRounded,
        FooterArea,
    },
    mounted () {
        document.body.classList.add('body-bg-f8faff')
    },
}
</script>